import React from 'react';
import './Hero.css';
import HeroCarousel from './HeroCarousel';

export default function Hero() {
  return (
    <header className="comp-hero">
      <div className="comp-hero-left">
        <h1 className="hero-title">Aurora Tech</h1>
        <div className="eyebrow">Trusted partner in your Digital Transformation</div>
        <p className="lead">We design, build, and maintain Smart SaaS Solutions & Custom Software for Businesses in Bangladesh and Beyond.</p>

        <div className="cta">
          <a className="btn primary" href="#contact">Contact Us</a>
          <a className="btn outline" href="#work">Our Projects</a>
        </div>

      </div>

      <div className="comp-hero-right">
        <HeroCarousel />
      </div>
    </header>
  );
}
